<div class="fluid-container p-4">
  <div class="resume-banner">
    <div class="banner-left w-100">
      <h1>Find your next role on BeExpert.ai</h1>
      <p>
        AI-powered job matching with proctored assessments and AI interviews
        built in.
      </p>

      <div class="search-wrapper-bg">
        <div class="search-filter-wrapper">
          <div class="search-box">
            <i class="bi bi-search"></i>

            <input type="text" placeholder="Search by role , company or keyword..." (input)="onSearch($event)" />
          </div>

          <div class="location-search">
            <input type="text" placeholder="Search Location" (input)="onLocationSearch($event)" />
          </div>

          <div class="filter-dropdown">
            <select (change)="onJobTypeChange($event)">
              <option value="">All Job Types</option>
              <option value="Full-Time">Full Time</option>
              <option value="Internship/Training">Internship</option>
              <option value="Part-Time">Part Time</option>
              <option value="Contract">Contract</option>
            </select>
          </div>
        </div>
      </div>
      <div class="features">
        <span [class.active]="selectedWorkMode === ''" (click)="onWorkModeChange('')">
          All
        </span>

        <span [class.active]="selectedWorkMode === 'Remote'" (click)="onWorkModeChange('Remote')">
          Remote
        </span>

        <span [class.active]="selectedWorkMode === 'Hybrid'" (click)="onWorkModeChange('Hybrid')">
          Hybrid
        </span>

        <span [class.active]="selectedWorkMode === 'Onsite'" (click)="onWorkModeChange('Onsite')">
          Onsite
        </span>
      </div>
    </div>
  </div>

  <ng-container *ngIf="isLoading; else pageContent">
    <div class="app-spinner">
      <mat-spinner diameter="60"></mat-spinner>
    </div>
  </ng-container>

  <ng-template #pageContent>
    <div class="resume-container">
      <div class="tabs-wrapper">
        <div class="tabs-group">
          <div class="custom-tab active" [class.active]="selectedTab === 'recommended'"
            (click)="changeTab('recommended')">
            <i class="bi bi-file-earmark-text"></i>
            Recommended
            <span *ngIf="selectedTab === 'recommended'">{{ recommendedCount }}</span>
          </div>

          <div class="custom-tab" class="custom-tab" [class.active]="selectedTab === 'all'" (click)="changeTab('all')">
            <i class="bi bi-briefcase"></i>
            All Jobs
            <span>{{ allJobsCount }}</span>
          </div>
        </div>

        <div class="tabs-group" routerLink="/student-dashboard/jobs/my-applications">
          <div class="custom-tab">
            <i class="bi bi-send-check"></i>
            My Applications
            <span>{{ myApplicationsCount }}</span>
          </div>

          <div class="custom-tab" routerLink="/student-dashboard/jobs/saved">
            <i class="bi bi-bookmark-heart"></i>
            Saved Jobs
            <span>{{ savedCount }}</span>
          </div>
        </div>
      </div>
      <ng-container *ngIf="jobData.length > 0; else noJobsFound">
        <div class="card-container">
          <div class="job-card" *ngFor="let job of jobData">
            <!-- Top -->
            <div class="job-top">
              <div class="company-info">
                <div class="company-logo">
                  <img *ngIf="job.company_logo; else noLogo" [src]="job.company_logo" alt="Company Logo"
                    class="company-img" />
                  <ng-template #noLogo>
                    <i class="bi bi-briefcase"></i>
                  </ng-template>
                </div>

                <div>
                  <p class="company-name" [matTooltip]="job.company_name">
                    {{ truncateText(job.company_name, 25) }}
                  </p>
                  <h3 [matTooltip]="job.job_title">
                    {{ truncateText(job.job_title, 35) }}
                  </h3>
                </div>
              </div>
              <i class="bi" [ngClass]="
                  job.is_saved
                    ? 'bi-bookmark-fill saved-bookmark'
                    : 'bi-bookmark'
                " (click)="toggleSaveJob(job)"></i>
            </div>

            <div class="job-tags">
              <ng-container *ngIf="job.job_type">
                <span>{{ job.job_type }}</span>
              </ng-container>

              <ng-container *ngIf="job.work_mode">
                <span class="active-tag">{{ job.work_mode }}</span>
              </ng-container>

              <ng-container *ngIf="job.locations.length">
                <span *ngFor="let location of job.locations"><i class="bi bi-geo-alt"></i> {{ location }}</span>
              </ng-container>
            </div>

            <div class="divider"></div>

            <div class="job-bottom">
              <ng-container *ngIf="job.number_of_openings">
                <div>
                  <i class="bi bi-people"></i>
                  {{ job.number_of_openings || "0" }} openings
                </div>
              </ng-container>

              <ng-container *ngIf="job.experience_level">
                <div>
                  <i class="bi bi-clock"></i>
                  {{ job.experience_level }}
                </div>
              </ng-container>

              <ng-container *ngIf="getDaysAgo(job.published_at)">
                <div>
                  <i class="bi bi-calendar3"></i>
                  {{ getDaysAgo(job.published_at) }}
                </div>
              </ng-container>
            </div>

            <button class="view-btn" (click)="goToJobsDetailPage(job.job_id)">
              View details
            </button>
          </div>
        </div>
      </ng-container>
      <ng-template #noJobsFound>
        <ng-container *ngIf="selectedTab === 'recommended'; else defaultEmpty">
          <div class="recommended-jobs-container">
            <div class="recommended-jobs-header d-flex justify-content-between align-items-center flex-wrap gap-3">
              <div class="d-flex align-items-center gap-3">
                <div class="header-icon-box">
                  <i class="bi bi-stars"></i>
                </div>
                <div>
                  <h3 class="mb-0">Recommended jobs for you</h3>
                  <p class="mb-0 text-muted">Complete your profile to get personalised matches</p>
                </div>
              </div>
            </div>

            <div class="recommended-jobs-content text-center mt-3">
              <div class="profile-icon-circle mx-auto mb-3">
                <i class="bi bi-person-plus"></i>
              </div>
              <h4>Get personalised job recommendations</h4>
              <p class="text-muted mx-auto" style="max-width: 550px;">
                Add your details, career preferences and resume so we can match you with the right roles.
              </p>
              <button class="btn btn-complete-profile mt-2" routerLink="/student-dashboard/profile">
                Complete your profile <i class="bi bi-arrow-right ms-2"></i>
              </button>
            </div>
          </div>
        </ng-container>
        <ng-template #defaultEmpty>
          <div class="empty-state-wrapper">
            <div class="empty-icon-container">
              <i class="bi bi-search"></i>
            </div>
            <h3 class="font-name empty-title">No Jobs Found</h3>
            <p class="empty-subtitle">We couldn't find any jobs matching your search criteria. Try adjusting your filters
              or check back later.</p>
          </div>
        </ng-template>
      </ng-template>
    </div>

    <div class="text-center mt-3 font-name" *ngIf="currentPage < totalPages">
      <button class="btn-add" (click)="loadMore()" [disabled]="isLoading">
        <ng-container *ngIf="isLoading; else showBtnText">
          <span class="spinner-border spinner-border-sm"></span> Loading...
        </ng-container>
        <ng-template #showBtnText>Load More</ng-template>
      </button>
    </div>
  </ng-template>
</div>